import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "imp-banner"
}
const _hoisted_2 = {
  key: 1,
  class: "offline-block-overlay"
}
const _hoisted_3 = { class: "offline-block-card" }
const _hoisted_4 = { class: "offline-block-status" }
const _hoisted_5 = {
  key: 0,
  class: "offline-badge"
}
const _hoisted_6 = {
  key: 1,
  class: "online-badge"
}
const _hoisted_7 = {
  key: 2,
  class: "sync-banner sync-banner--active"
}
const _hoisted_8 = {
  key: 0,
  class: "update-banner update-banner--auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppDialogs = _resolveComponent("AppDialogs")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass({ 'app--impersonating': _ctx.impersonatedBy })
  }, [
    (_ctx.impersonatedBy)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[4] || (_cache[4] = _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M12 2a5 5 0 0 0-5 5v2a5 5 0 0 0 10 0V7a5 5 0 0 0-5-5z" }),
            _createElementVNode("path", { d: "M4 22a8 8 0 0 1 16 0" })
          ], -1)),
          _createElementVNode("span", null, [
            _cache[2] || (_cache[2] = _createTextVNode("Você está no sistema desta obra como ", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("strong", null, "administrador", -1)),
            _createTextVNode(" (suporte, iniciado por " + _toDisplayString(_ctx.impersonatedBy) + ").", 1)
          ]),
          _createElementVNode("button", {
            class: "imp-exit",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exitImpersonation && _ctx.exitImpersonation(...args)))
          }, "Sair e voltar ao painel")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _createVNode(_component_AppDialogs),
    (_ctx.offlineBlocked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("svg", {
              width: "48",
              height: "48",
              viewBox: "0 0 48 48",
              fill: "none"
            }, [
              _createElementVNode("circle", {
                cx: "24",
                cy: "24",
                r: "22",
                stroke: "#d83b01",
                "stroke-width": "2.5"
              }),
              _createElementVNode("path", {
                d: "M14 14l20 20M34 14L14 34",
                stroke: "#d83b01",
                "stroke-width": "2.5",
                "stroke-linecap": "round"
              })
            ], -1)),
            _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Acesso offline expirado", -1)),
            _createElementVNode("p", null, "Você ficou offline por mais de " + _toDisplayString(_ctx.daysOffline) + " dias. Conecte-se à internet para continuar usando o sistema.", 1),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.isOffline)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("svg", {
                      width: "10",
                      height: "10",
                      viewBox: "0 0 10 10",
                      fill: "none"
                    }, [
                      _createElementVNode("circle", {
                        cx: "5",
                        cy: "5",
                        r: "4",
                        fill: "#d83b01"
                      })
                    ], -1),
                    _createTextVNode(" Sem conexão ", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("svg", {
                      width: "10",
                      height: "10",
                      viewBox: "0 0 10 10",
                      fill: "none"
                    }, [
                      _createElementVNode("circle", {
                        cx: "5",
                        cy: "5",
                        r: "4",
                        fill: "#107c10"
                      })
                    ], -1),
                    _createTextVNode(" Conectado — sincronizando… ", -1)
                  ]))]))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "sync-banner" }, {
      default: _withCtx(() => [
        (_ctx.offlinePendingCount > 0 && !_ctx.isOffline && !_ctx.offlineSyncing)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sync-banner",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.triggerSync && _ctx.triggerSync(...args)))
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  d: "M12 7A5 5 0 112 7",
                  stroke: "currentColor",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round"
                }),
                _createElementVNode("path", {
                  d: "M12 4v3h-3",
                  stroke: "currentColor",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.offlinePendingCount) + " relatório(s) aguardando envio — clique para sincronizar ", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.offlineSyncing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("svg", {
            class: "spin",
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none"
          }, [
            _createElementVNode("path", {
              d: "M12 7A5 5 0 112 7",
              stroke: "currentColor",
              "stroke-width": "1.5",
              "stroke-linecap": "round"
            })
          ], -1),
          _createTextVNode(" Sincronizando relatórios… ", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "update-banner" }, {
      default: _withCtx(() => [
        (_ctx.applyingUpdate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("svg", {
                class: "spin",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("polyline", { points: "23 4 23 10 17 10" }),
                _createElementVNode("path", { d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10" })
              ], -1),
              _createElementVNode("span", null, "Atualizando para a nova versão…", -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}